import AntdNotification from 'antd/lib/notification';
import 'antd/lib/notification/style';

const notification = {
    ...AntdNotification,
}
export default notification;



// WEBPACK FOOTER //
// ./src/components/notification/index.tsx